/*
 * @Author: dengjiayao
 * @Date:   2019-07-05 14:38:13
 * @Last Modified by: dengjiayao
 * @Last Modified time: 2019-11-06 10:08:53
 */
import request from '@/utils/request'
import * as I from './interface'

const withDialogIdsTimeRange = (data: I.QaListParams): I.QaListParams => {
  if (!data.dialogIds?.length || data.beginTimestamp === undefined) {
    return data
  }

  if (data.endTimestamp !== undefined) return data

  return { ...data, endTimestamp: data.beginTimestamp + 1 }
}
/**
 * 左侧会话列表查询
 */
export const searchQaList = (values: I.QaListParams): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/list/xh`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}



export const searchQaListAll = (values: I.QaListParams): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/all`, {
    method: 'post',
    params: extraData,
    data: withDialogIdsTimeRange(rest),
    autoHump: true,
  })
}

/**
 * 左侧会话列表查询(消警记录页面查询)
 */
export const searchEliminateList = (values: any): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/wipe_record/list`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}

export const allMessages = (values: any): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/all/messages`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}
/**
 * 会话消息查询
 */
export const fetchDialogMessages = (values: I.GetDialogMessages): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/messages`, {
    method: 'get',
    params: { ...rest },
    autoHump: true,
  })
}

/**
 * 跨平台会话消息查询（左侧列表走 /dialog/all 时配套使用）
 */
export const fetchDialogMessagesV2 = (values: I.GetDialogMessages): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/messages_v2`, {
    method: 'get',
    params: { ...rest },
    autoHump: true,
  })
}

/**
 * 会话对应订单查询
 */
export const fetchOrderInfo = (values: I.GetOrderInfo): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/order_info`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}

/**
 *  列出所有人工标签
 */
export const fetchHumanQaRules = (values: I.GetHumanTag): Promise<any> => {
  const {
    extraData: { seller_nick, ...restExtraData },
    ...rest
  } = values
  return request(`/api/v1/qc_norm/tag/list_by_account`, {
    method: 'post',
    data: { ...rest, ...restExtraData },
    autoHump: true,
  })
}

/**
 *  记录人工复查标签
 */
export const saveHumanTags = (values: I.SaveHumanTag): Promise<any> => {
  const { ...rest } = values
  return request(`/api/v1/dialog/mark/save`, {
    method: 'post',
    data: rest,
    autoHump: true,
  })
}

// 处理告警
export const handleAlarm = (params: any): Promise<any> => {
  return request(`/api/v1/dialog/finish_warning`, {
    method: 'post',
    data: params,
  })
}

/**
 * 查询某天的历史消息
 */
export const fetchDayMessages = (values: I.HistoryMessage): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/other_day_messages`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}

/**
 * 查询某天的历史消息（跨平台会话，左侧列表走 /dialog/all 时配套使用）
 */
export const fetchDayMessagesV2 = (values: I.HistoryMessage): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/other_day_messages_v2`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}

/**
 * 消警
 */
export const scoreWipe = (values: I.ScoreWipe): Promise<any> => {
  const { ...rest } = values
  return request(`/api/v1/dialog/score/wipe`, {
    method: 'post',
    data: rest,
    autoHump: true,
  })
}

/**
 * 保存备注
 */
export const saveMark = (values: I.SaveMark): Promise<any> => {
  const { ...rest } = values
  return request(`/api/v1/dialog/mark`, {
    method: 'post',
    data: rest,
    autoHump: true,
  })
}
/**
 * 保存检查
 */
export const saveInspector = (values: I.SaveMark): Promise<any> => {
  const { ...rest } = values
  return request(`/api/v1/dialog/inspector/save`, {
    method: 'post',
    data: rest,
    autoHump: true,
  })
}

/**
 * 获取焦点商品
 */
export const fetchFocusGoods = (values: I.FocusGoods): Promise<any> => {
  return request(`/api/v1/dialog/goods`, {
    method: 'get',
    params: values,
    autoHump: true,
  })
}

/**
 * 监管提醒客服跟进
 */
export const sendRemind = (params: I.Remind): Promise<any> => {
  return request(`/api/v1/stat/kefu/reminder/remind`, {
    method: 'post',
    data: params,
    autoHump: true,
  })
}

/**
 * 分享链接
 */
export const shareUrl = (params: I.ShareUrl): Promise<any> => {
  return request(`/api/v1/dialog/share_url`, {
    method: 'post',
    data: params,
    autoHump: true,
  })
}

/**
 * 会话案例库会话接口
 */

/**
 * 左侧会话案例列表查询
 */
export const searchCaseList = (values: I.CaseListParams): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/case/list`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}
export const searchAllList = (data: any): Promise<any> => {
  return request(`/api/v1/dialog/all/list`, {
    method: 'post',
    data,
    autoHump: true,
  })
}
/**
 * 左侧会话案例列表查询
 */
export const searchHistoryList = (values: I.CaseListParams): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/farther/list`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}

/**
 * 会话案例消息查询
 */
export const fetchCaseDialogMessages = (values: I.GetCaseDialogMessages): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/case/messages`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}

/**
 * 历史会话查询
 */
export const fetchHistoryDialogMessages = (values: I.GetCaseDialogMessages): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/farther/messages`, {
    method: 'get',
    params: { ...rest },
    autoHump: true,
  })
}

/**
 * 会话案例查询某天的历史消息
 */
export const fetchCaseDayMessages = (values: I.HistoryMessage): Promise<any> => {
  const { extraData, ...rest } = values
  return request(`/api/v1/dialog/case/history/messages`, {
    method: 'post',
    params: extraData,
    data: rest,
    autoHump: true,
  })
}

/**
 * 分享会话案例链接
 */
export const shareCaseUrl = (params: I.ShareCaseUrl): Promise<any> => {
  return request(`/api/v1/dialog/case/share`, {
    method: 'post',
    data: params,
    autoHump: true,
  })
}

/**
 * 打标签，优秀，待改进,取消标记
 */
export const saveJudge = (values: I.SaveJudge): Promise<any> => {
  return request(`/api/v1/dialog/case/add`, {
    method: 'post',
    data: values,
    autoHump: true,
  })
}

export const updateJudge = (values: I.SaveJudge): Promise<any> => {
  return request(`/api/v1/dialog/case/patch`, {
    method: 'post',
    data: values,
    autoHump: true,
  })
}

export const fetchDialogCase = (values: I.CaseDetail): Promise<any> => {
  return request(`/api/v1/dialog/case/detail`, {
    method: 'post',
    data: values,
  })
}

export const saveSimple = (values: any): Promise<any> => {
  return request(`/api/v1/message/mark`, {
    method: 'post',
    data: values,
  })
}

export const clearSingleTags = (values: any): Promise<any> => {
  return request(`/api/v1/message/mark/clear`, {
    method: 'post',
    data: values,
  })
}

export const fetchWarningList = (values: any): Promise<any> => {
  return request(`/api/v1/dialog/warning_msg_list`, {
    method: 'post',
    data: values,
  })
}

export const finishWarnings = (values: any): Promise<any> => {
  return request(`/api/v1/dialog/finish_warnings`, {
    method: 'post',
    data: values,
  })
}

// 重放消息查询
export const fetchRehearsalMessages = (values: any): Promise<any> => {
  return request(`/api/v1/rehearsal/task/dialog/messages`, {
    method: 'post',
    data: values,
    autoHump: true,
  })
}

// 获取重放会话列表
export async function fetchRehearsalDialogs(params): Promise<ResponseData<null>> {
  return request('/api/v1/rehearsal/task/dialog/list', {
    method: 'post',
    data: params,
    autoHump: true,
  })
}

export type GetOtherMessagesParams = {
  platform: 'tb' | 'jd' | 'wx' // tb jd wx
  remark: string // 企微的备注
  cnick: string // 京东淘宝的昵称
}

export const getOtherMessages = (params: GetOtherMessagesParams): Promise<any> => {
  return request(`/api/v1/dialog/other_pf_dialog`, {
    method: 'post',
    data: params,
    autoHump: true,
  })
}
